import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageModule } from '@nano/common/image';
import { L10nTranslationModule } from 'angular-l10n';
import { EmptyInboxComponent } from './empty-inbox.component';

@NgModule({
  imports: [CommonModule, L10nTranslationModule, ImageModule],
  declarations: [EmptyInboxComponent],
  exports: [EmptyInboxComponent]
})
export class EmptyInboxModule {}
